import React, { useState } from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface Option {
  value: string;
  label: string;
}

interface FilterSectionProps {
  title: string;
  icon: typeof LucideIcon;
  options: (string | Option)[];
  selectedFilters: string[];
  onFilterToggle: (filter: string) => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  title,
  icon: Icon,
  options,
  selectedFilters,
  onFilterToggle
}) => {
  const [showAll, setShowAll] = useState(false);
  const initialVisibleItems = 4;
  const visibleOptions = showAll ? options : options.slice(0, initialVisibleItems);

  return (
    <div className="space-y-4">
      <h3 className="font-medium text-gray-700 flex items-center space-x-2">
        <Icon className="h-5 w-5 text-orange-500" />
        <span>{title}</span>
      </h3>
      <div className="space-y-2">
        {visibleOptions.map((option) => {
          const value = typeof option === 'string' ? option : option.value;
          const label = typeof option === 'string' ? option : option.label;
          
          return (
            <label key={value} className="flex items-center space-x-2">
              <input
                type="checkbox"
                className="rounded text-orange-500 focus:ring-orange-500"
                checked={selectedFilters.includes(value)}
                onChange={() => onFilterToggle(value)}
              />
              <span className="text-gray-600">{label}</span>
            </label>
          );
        })}
      </div>
      
      {options.length > initialVisibleItems && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="text-sm text-orange-500 hover:text-orange-600 transition-colors"
        >
          {showAll ? 'Weniger zeigen' : `Zeige ${options.length - initialVisibleItems} mehr`}
        </button>
      )}
    </div>
  );
};

export default FilterSection;